import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

export default function DeleteModal({
  show,
  close,
  onDelete,
  title = "Delete",
  message = "Are you sure you want to delete this item?",
   itemName,
}) {
  return (
    <Modal 
    show={show} 
    onHide={close} 
    centered
    className="hashtag-add-modal"
    >
      <Modal.Header className="hashtag-modal-header">
        <Modal.Title>{title}</Modal.Title>
         <button
          type="button"
          className="hashtag-close-btn"
           onClick={close}
        >
          ×
        </button>
      </Modal.Header>

      <Modal.Body className="hashtag-modal-body">
        {message}
        {itemName && (
          <div style={{ marginTop: 8, fontWeight: 600 }}>
            "{itemName}"
          </div>
        )}
      </Modal.Body>

      <Modal.Footer className="hashtag-modal-footer">
        <Button variant="secondary" onClick={close}  className="hashtag-close-footer-btn">
          Cancel
        </Button>

        <Button variant="danger" onClick={onDelete} className="hashtag-save-btn">
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
}